// extracted by mini-css-extract-plugin
export default {"wrap":"bH-z","fullWidth":"cH-z","hideOnDesktop":"dH-z","content":"eH-z","hasOpenedNav":"fH-z","crumbsList":"gH-z","dropdownsWrap":"hH-z"};